import React from 'react';
import {
  ChatWithUsContainer,
  ChatButton,
  Text,
} from './style/ChatWithUsWMO.css';
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks';

const ChatWithUsWMO = ({ text = '', linkText = '', OpenChatHandler }) => {
  const isSparkChatEnabled = useSparkChatEnabled();

  return (
    <ChatWithUsContainer>
      <Text>{text || 'Need help?'}</Text>
      <ChatButton type="button" onClick={OpenChatHandler}>
        {linkText || isSparkChatEnabled ? 'Chat With Spark' : 'Chat With Us'}
      </ChatButton>
    </ChatWithUsContainer>
  );
};

export default ChatWithUsWMO;
